import { ContentType } from "modules/common/models";

/**
 * Helper function to open a post or event in private user portal. Defaults to posts url.
 * @param tenantId
 * @param postId
 * @param contentType
 */
const openContentInPortal = (tenantId: string, postId: string, contentType: ContentType = ContentType.Post) => {
    const hrefToOpen = `/${tenantId}/${ContentType[contentType].toLowerCase()}s/${postId}`;
    const url = `${window.location.origin}${hrefToOpen}`;
    const newWindow = window.open(url, "_blank");

    if (newWindow !== null)
        newWindow.focus();
}

export { openContentInPortal };
